import { size } from 'lodash/fp';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Identifiable } from '@mews/std';
import { IconButton, IconName, Stack, StackItem } from '@optimus-web/core';
import { Option, ApplicationState } from '@mews-commander/types';
import { Select } from '@mews-commander/ui';
import { getCurrentMonth, getMonthOptions } from '../../../selectors';
import { changeMonth } from '../../../actions/formActions';

interface StateProps {
    options: Array<Option>;
    currentMonth: number;
}

interface DispatchProps {
    handleChange(month: number): void;
}

const MonthSelector = ({ handleChange, options, currentMonth }: StateProps & DispatchProps) => {
    const hasPrevMonth = currentMonth > 0;
    const hasNextMonth = currentMonth < size(options) - 1;

    const handlePrevMonth = () => handleChange(currentMonth - 1);
    const handleNexMonth = () => handleChange(currentMonth + 1);

    return (
        <Stack spacing="100" itemAlignment="center">
            <IconButton
                size="small"
                variant="ghost"
                icon={IconName.ChevronLeft}
                onClick={handlePrevMonth}
                disabled={!hasPrevMonth}
                type="submit"
            />
            <StackItem width="200px">
                <Select options={options} onChange={handleChange} selected={currentMonth} inline />
            </StackItem>
            <IconButton
                size="small"
                variant="ghost"
                icon={IconName.ChevronRight}
                onClick={handleNexMonth}
                disabled={!hasNextMonth}
                type="submit"
            />
        </Stack>
    );
};

export default connect<StateProps, DispatchProps, Identifiable, ApplicationState>(
    createStructuredSelector({
        options: getMonthOptions,
        currentMonth: getCurrentMonth,
    }),
    {
        handleChange: changeMonth,
    }
)(MonthSelector);
